export default "__VITE_ASSET__Du$yU97c__"